export default __webpack_public_path__ + "static/media/dyno.c2a53bcf.png";